<template>
  <main role="main">
    <div class="d-lg-flex" id="main-wraper">
      <div class="page-wrapper" style="width: 140%">
        <div class="page-content">
          <div class="row mb-4 justify-content-center">
            <div class="col-lg-12">
              <div class="row p-3 align-items-center">
                <div class="col-md-6 col-5">
                  <h2 class="page-title mb-md-0">
                    <a
                      href="javascript:void(0)"
                      v-on:click="$router.go(-1)"
                      class="back-arrow"
                    >
                      <i class="bx bx-arrow-back"></i
                    ></a>
                    {{ $t("label.Manage Suppliers") }}
                  </h2>
                </div>
              </div>

              <ul
                class="col-12 nav nav-pills mb-3 tab-style-1"
                id="pills-tab"
                role="tablist"
              >
                <li class="col-4 nav-item text-center" role="presentation">
                  <a
                    class="nav-link"
                    id="pending_orders-tab"
                    data-toggle="pill"
                    role="tab"
                    :class="{ active: currentTab == 'PENDING' }"
                    v-on:click="changeTab('PENDING')"
                    style="cursor: pointer"
                    >{{ $t("label.Pending") }}</a
                  >
                </li>
                <li class="col-4 nav-item text-center" role="presentation">
                  <a
                    class="nav-link"
                    id="accepted_orders-tab"
                    data-toggle="pill"
                    role="tab"
                    :class="{ active: currentTab == 'ACCEPTED' }"
                    v-on:click="changeTab('ACCEPTED')"
                    style="cursor: pointer"
                    >{{ $t("label.Accepted") }}</a
                  >
                </li>
                <li class="col-4 nav-item text-center" role="presentation">
                  <a
                    class="nav-link"
                    id="rejected_orders-tab"
                    data-toggle="pill"
                    role="tab"
                    :class="{ active: currentTab == 'REJECTED' }"
                    v-on:click="changeTab('REJECTED')"
                    style="cursor: pointer"
                    >{{ $t("label.Rejected") }}</a
                  >
                </li>
              </ul>
              <div class="tab-content bg-white rounded p-3" id="pills-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="pending_orders"
                  role="tabpanel"
                  aria-labelledby="pending_orders-tab"
                >
                  <div class="row mb-3">
                    <div class="col-lg-6 col-md-4 d-md-flex mb-md-0 mb-2">
                      <div class="input-group page-cont-search border col-md-6">
                        <span class="input-group-text"><i class="bx bx-search"></i></span>
                        <input
                          type="text"
                          class="form-control"
                          name=""
                          v-on:keyup.enter="getSupplierList(1)"
                          :placeholder="$t('label.search here')"
                          v-model="searchObj.keyword"
                        />
                      </div>
                    </div>
                    <div
                      class="col-md-6 col-7 text-right d-md-flex justify-content-end mb-3"
                    >
                      <button
                        type="button"
                        class="btn btn-brand-1 btn-sm"
                        v-on:click="$router.push('/add-Supplier')"
                        v-if="access.can_create"
                      >
                        <i class="bx bx-plus"></i> {{ $t("label.Add") }}
                      </button>
                    </div>
                  </div>
                  <table class="table table-style-1 table-responsive" id="sorting_tbl">
                    <thead>
                      <tr>
                        <th>{{ $t("label.S_No") }}</th>
                        <th>{{ $t("label.Supplier Name") }}</th>
                        <th>{{ $t("label.Email") }}</th>
                        <th>{{ $t("label.Phone Number") }}</th>
                        <th>{{ $t("label.Action") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in supplierList" :key="index">
                        <td>{{ (currentPage - 1) * itemsPerPage + index + 1 }}</td>
                        <td>{{ data.name }}</td>
                        <td>{{ data.email }}</td>
                        <td>
                          {{ data.phone_number }}
                        </td>
                        <td>
                          <button
                            class="btn btn-action mr-2 mb-md-0 mb-2 text-secondary"
                            v-show="currentTab == 'PENDING' || currentTab == 'REJECTED'"
                            v-on:click="$router.push('/supplier-detail/' + data.id)"
                            title="View"
                            v-if="access.can_read"
                          >
                            <i class="bx bx-show"></i>
                          </button>
                          <button
                            v-show="currentTab == 'PENDING'"
                            class="btn btn-action mr-2 mb-md-0 mb-2 text-success"
                            v-on:click="status('ACCEPTED', data.id)"
                            title="Accept"
                          >
                            <i class="bx bxs-check-circle"></i>
                          </button>
                          <button
                            v-show="currentTab == 'PENDING'"
                            class="btn btn-action mr-2 mb-md-0 mb-2 text-danger"
                            v-on:click="status('REJECTED', data.id)"
                            title="Reject"
                          >
                            <i class="bx bxs-x-circle"></i>
                          </button>
                          <button
                            class="btn btn-action mr-2 mb-md-0 mb-2 text-secondary"
                            v-on:click="router(data.id)"
                            v-if="data.supplier_status == 'ACCEPTED' && access.can_update"
                            title="Edit"
                          >
                            <i class="bx bxs-pencil"></i>
                          </button>
                          <button
                            class="btn btn-action mr-2 mb-md-0 mb-2 text-danger"
                            v-if="data.supplier_status == 'ACCEPTED' && access.can_delete"
                            v-on:click="showDeletePopup(data.id)"
                            title="Delete"
                          >
                            <i class="bx bxs-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <ErrorComponent @retry="getSupplierList(1)" ref="errorComponent" />
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-lg-12 mt-3">
                  <div class="page-bottom-pagination text-right">
                    <Pagination
                      @page-change="pageChange"
                      @items-per-page-change="itemsPerPageChange"
                      ref="listPagination"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <DeleteModal @remove="deleteRecord" ref="deleteModal" />
</template>

<script>
// import moment from "moment";
import DeleteModal from "@/components/DeleteModal";
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "../../components/Pagination.vue";
export default {
  name: "ManageProductOrder",
  components: {
    ErrorComponent,
    Pagination,
    DeleteModal,
  },
  data() {
    return {
      currentTab: "PENDING",
      supplierList: [],
      searchObj: {
        keyword: "",
        status: "PENDING",
        offset: 0,
      },
      currentPage: 1,
      access: { can_create: 1, can_update: 1, can_read: 1, can_delete: 1 },
      loader: true,
      itemsPerPage: 10,
    };
  },
  mounted() {
    this.getSupplierList(1);
  },
  methods: {
    changeTab(tab) {
      this.currentTab = tab;
      if (tab == "PENDING") {
        this.searchObj.status = "PENDING";
        this.getSupplierList(0);
      } else if (tab == "ACCEPTED") {
        this.searchObj.status = "ACCEPTED";
        this.getSupplierList(0);
      } else if (tab == "REJECTED") {
        this.searchObj.status = "REJECTED";
        this.getSupplierList(0);
      }
    },
    pageChange(page) {
      this.getSupplierList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getSupplierList(1);
    },
    getSupplierList(page, sortBy, orderBy) {
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.searchObj.sort_order = orderBy;
      }
      if (!page) {
        page = 1;
      }
      this.searchObj.offset = page - 1;
      this.currentPage = page;
      // this.searchObj.row_per_page = this.itemsPerPage;

      this.supplierList = [];
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateLoader(true);
      }
      this.$api
        .getAPI({
          _action: "suppliers",
          _body: this.searchObj,
        })
        .then((res) => {
          this.supplierList = res.list;
          this.access = res.manage_suppliers;
          this.searchObj.offset = res.next_offset;

          if (this.$refs.listPagination) {
            this.$refs.listPagination.currentPage = this.currentPage;
            if (res.count != null && res.count > 0 && this.access.can_read) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (this.$refs.errorComponent) {
            if (this.access.can_read == 0) {
              this.$refs.errorComponent.setData(res, this.$t("label.Sorry, you don't have permission"));
              this.$refs.errorComponent.updateLoader(false);
              return;
            }
            this.$refs.errorComponent.setData(res, this.$t("label.Supplier Not Available"));
            this.$refs.errorComponent.updateLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateLoader(false);
          }
        });
    },
    router(id) {
      this.$router.push("/edit-supplier/" + id);
    },
    updateOrderStatus(id, status) {
      var obj = {};
      if (status == "REJECTED") {
        obj.reason = "rejected";
      }

      obj.status = status;
      this.$api
        .putAPI({
          _action: "order/status/" + id,
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getSupplierList(0);
          }
        })
        .catch(() => {});
    },
    status(status, id) {
      var obj = {};
      obj.supplier_status = status;
      this.$api
        .postAPI({
          _action: "supplier/change-status/" + id,
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.info.message,
          });
          this.getSupplierList(0);
        })
        .catch(() => {});
    },
    showDeletePopup(id) {
      this.$refs.deleteModal.showModal(
        this.$t("label.Delete"),
        this.$t("label.Are you sure you want to delete"),
        id
      );
    },
    deleteRecord(id) {
      this.loader = true;
      this.$api
        .deleteAPI({
          _action: "supplier/" + id,
        })
        .then((res) => {
          this.loader = false;
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.$refs.deleteModal.closeModal();
          this.getSupplierList(0);
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>

